import axios from "axios"
import { ElMessage } from "element-plus"

const instance = axios.create({
  baseURL: 'https://manage.zgeec.com/prod-api', //环境
  timeout: 20000, //20秒
})
// const globalStore = GlobalStore();
// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {

    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error) //
  }
)
// 添加响应拦截器
instance.interceptors.response.use(
  async (response) => {
    if (response.status !== 200) { // 成功的 code 码一般是 200，当然 code 字段不一定存在，这里处理请求失败的操作
      ElMessage.error("服务器错误")
      return Promise.reject(new Error(response.msg || 'Error'))
    } else {
      if (response.data.status === 400) {
        ElMessage.error(response.data.msg || response.data.name)
        return response
      } else {
        // 返回正常的请求数据
        return response
      }

    }
  },
  (error) => {
    if (error.response && error.response.status === 500) {
      ElMessage.error("服务器请求失败")
    }
    return Promise.reject(error)
  }
)

export default instance
